const port = new URL('../../icons/port-flow.png', import.meta.url).href

export default {
  type: 'PortFlow',
  description: 'port flow',
  icon: port,
  group: ['etc'],
  model: {
    type: 'PortFlow',
    left: 100,
    top: 100,
    width: 80,
    height: 20,
    fillStyle: 'black',
    strokeStyle: 'black'
  }
}
